<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90" style="width: 100%; left: 0;">
      <v-toolbar-title class="toolbar-title">Antecedentes | Observaciones - Informes de Partidos</v-toolbar-title>
    </v-toolbar>

    <v-tabs v-model="tabCategoria" color="grey lighten-2" centered grow show-arrows icons-and-text height="72"
      class="tabs-categorias" style="position: absolute; top: 90px; width: 100%; left: 0; z-index: 2;">
      <v-tab v-for="cat in categorias" :key="cat.id">
        {{ cat.description }}
        <v-icon>fa-trophy</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs v-model="tabClub" color="grey lighten-2" show-arrows icons-and-text height="72" class="tabs-clubes"
      style="position: absolute; top: 162px; width: 100%; left: 0; z-index: 1;">

      <v-tab style="display: none;"></v-tab>

      <v-tab v-for="club in clubesFiltrados" :key="club.pk">
        {{ club.nombre }}
        <img v-if="club.logo" :src="club.logo" class="club-tab-logo">
        <v-icon v-else>mdi-shield-half-full</v-icon>
      </v-tab>
    </v-tabs>

    <v-divider style="margin-top: 210px;"></v-divider>

    <v-content class="body-content">
<div class="no-content-container" v-if="(loading || (selectedClubId && !busquedaCompletada)) && this.$store.state.permissions.canViewObservacionesPreviasInformes">
        <v-flex mt-5>
          <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
        </v-flex>
        <span style="padding-top: 1em;">Cargando...</span>
      </div>

      <div class="no-content-container" v-else-if="!selectedClubId && this.$store.state.permissions.canViewObservacionesPreviasInformes">
        <v-icon color="676767" class="mt-4">fa-search</v-icon>
        <span class="mt-2">Seleccione un club para ver sus antecedentes | observaciones</span>
      </div>

      <div v-else-if="this.$store.state.permissions.canViewObservacionesPreviasInformes && busquedaCompletada" class="ruta-container">
        <div
          style="margin-left: 10px; margin-top: 15px; margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
          <span v-if="partidosAgrupados.length > 0" style="font-size: 0.8em;">Búsqueda realizada a través de los últimos 10 informes</span>
          <v-chip v-if="cantidadConObservaciones > 0" small color="info" text-color="white"
            class="font-weight-bold ma-0">
            {{ cantidadConObservaciones }} informes(s) con sanciones
          </v-chip>
        </div>

        <div class="no-content-container" v-if="partidosAgrupados.length === 0 && !loading && busquedaCompletada">
          <v-icon color="676767" large>mdi-alert</v-icon>
          <span class="mt-2">No hay sanciones registradas para este club en esta categoría.</span>
        </div>

        <v-expansion-panel v-else class="panel-compacto" v-model="panelState">
          <v-expansion-panel-content v-for="item in partidosAgrupados" :key="item.partido.id" class="borde-estado"
          :style="{ '--color-estado': getPartidoColor(item.partido) }" :readonly="item.sanciones.length === 0" :class="{ 'panel-sin-sanciones': item.sanciones.length === 0 }"
          :hide-actions="item.sanciones.length === 0">
            <div slot="header" class="header-partido"
              style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">

              <div style="display: flex; align-items: center;">

                <img :src="item.partido.clubLocal.logo" class="logo-mini mr-2" alt="local">

                <strong style="font-size: 1.1em;" v-if="selectedClubId === item.partido.clubLocal.id">{{ item.partido.clubLocal.nombre }}</strong>
                <span style="font-size: 1.1em;" v-else>{{ item.partido.clubLocal.nombre }}</span>
                <div class="mx-3 d-flex align-center font-weight-bold" style="font-size: 1.1em;">
                  <span>{{ item.partido.localGoals }}</span>
                  <span v-if="item.partido.localPenaltyGoals != null" class="ml-1 text-muted" style="font-size: 0.9em;">
                    ({{ item.partido.localPenaltyGoals }})
                  </span>

                  <span class="mx-2 text-muted font-weight-regular" style="font-size: 0.85em;">vs</span>

                  <span>{{ item.partido.visitorGoals }}</span>
                  <span v-if="item.partido.visitorPenaltyGoals != null" class="ml-1 text-muted"
                    style="font-size: 0.9em;">
                    ({{ item.partido.visitorPenaltyGoals }})
                  </span>
                </div>

                <img :src="item.partido.clubVisitor.logo" class="logo-mini mr-2" alt="visitante">
                <strong style="font-size: 1.1em;" v-if="selectedClubId === item.partido.clubVisitor.id">{{ item.partido.clubVisitor.nombre
                  }}</strong>
                <span style="font-size: 1.1em;" v-else>{{ item.partido.clubVisitor.nombre }}</span>
              </div>

              <div style="display: flex; align-items: center; gap: 5px;"
                v-if="item.partido.countAdvertencias === 0 && item.partido.countIncumplimientos === 0">
                <v-icon color="green darken-2" small>mdi-check-circle</v-icon>
                <span>Sin sanciones</span>
              </div>

              <div style="display: flex; align-items: center; gap: 5px;" v-if="item.partido.countAdvertencias > 0">
                <v-icon color="orange darken-2" small>mdi-alert</v-icon>
                <span>{{ item.partido.countAdvertencias }}</span>
              </div>

              <div style="display: flex; align-items: center; gap: 5px;" v-if="item.partido.countIncumplimientos > 0">
                <v-icon color="red darken-1" small>mdi-alert-circle</v-icon>
                <span>{{ item.partido.countIncumplimientos }}</span>
              </div>

              <v-spacer></v-spacer>

              <div style="display: flex; align-items: center; gap: 25px; margin-right: 10px">

                <div style="display: flex; align-items: center;">
                  <v-icon small color="grey" class="mr-1">mdi-calendar-clock</v-icon>
                  <span>{{ item.partido.dateRealization }}</span>
                </div>

                <div style="display: flex; align-items: center;" v-if="item.partido.torneo">
                  <v-icon small color="grey" class="mr-1">fa-trophy</v-icon>
                  <span>{{ item.partido.torneo }} - {{ item.partido.fecha.description }}</span>
                </div>

                <div style="display: flex; align-items: center;" v-if="item.partido.stadium">
                  <v-icon small color="grey" class="mr-1">mdi-stadium</v-icon>
                  <span>{{ item.partido.stadium.description }}</span>
                </div>

              </div>
            </div>

            <v-card>
              <v-card-text class="grey lighten-4 pa-2">
                <v-card v-for="sancion in item.sanciones" :key="sancion.id" class="mb-1 pa-2 sancion-card"
                  :style="{ 'border-left': `4px solid ${getSancionColorHex(sancion.sanction.description)}` }">
                  <v-layout row wrap align-start>
                    <v-flex xs12 md2 class="pr-4 pl-2">
                      <div style="font-size: 0.6em; color: #293968;">Sección</div>
                      <span style="font-size: 0.8em;">{{ sancion.seccionNombre }}</span>
                    </v-flex>

                    <v-flex xs12 md2 class="pr-4">
                      <div style="font-size: 0.6em; color: #293968;">Campo</div>
                      <span style="font-size: 0.8em;">{{ sancion.description }}</span>
                    </v-flex>

                    <v-flex xs12 md3 class="pr-2">
                      <div style="font-size: 0.6em; color: #293968;">Respuesta</div>
                      <p class="mb-0" style="font-size: 0.7em; margin-right: 10px;">{{ sancion.responseValue || '-' }}
                      </p>
                    </v-flex>

                    <v-flex xs12 md2 class="pr-2">
                      <div style="font-size: 0.6em; color: #293968;">Observación</div>
                      <p class="mb-0" style="font-size: 0.7em; margin-right: 10px;">{{ sancion.observation || '-' }}
                      </p>
                    </v-flex>

                    <v-flex xs12 md1 class="pr-2">
                      <div style="font-size: 0.6em; color: #293968;">Escala</div>
                      <p class="mb-0" style="font-size: 0.7em; margin-right: 10px;">{{ sancion.scaleValue || '-' }}
                      </p>
                    </v-flex>

                    <v-flex xs12 md1 >
                      <div style="font-size: 0.6em; color: #293968;">Sanción</div>
                      <v-chip :color="getSancionColor(sancion.sanction.description)" text-color="white" small>
                        {{ sancion.sanction.description }}
                      </v-chip>
                    </v-flex>
                  </v-layout>

                  <v-expansion-panel v-if="sancion.fieldAdjuntos && sancion.fieldAdjuntos.length > 0" flat
                    class="adjuntos-panel elevation-0 mt-2">
                    <v-expansion-panel-content>
                      <div slot="header" class="d-flex align-center">
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="blue" small class="mr-1">mdi-paperclip</v-icon>
                          <span class="blue--text " style="font-size: 0.7em;">
                            Ver {{ sancion.fieldAdjuntos.length }} adjunto(s)
                          </span>
                        </div>
                      </div>

                      <v-card flat color="transparent">
                        <v-card-text class="pa-0 pt-2 border-top-light">

                          <div v-if="sancion.imageAdjuntos && sancion.imageAdjuntos.length > 0"
                            style="display: flex; justify-content: center; width: 100%; max-width: 650px; margin: 10px auto;">
                            <CarouselInforme :attachments="sancion.imageAdjuntos"></CarouselInforme>
                          </div>

                          <div v-if="sancion.filesAdjuntos && sancion.filesAdjuntos.length > 0" class="mt-2">
                            <div class="caption grey--text mb-1">Documentos:</div>
                            <div v-for="item in sancion.filesAdjuntos" :key="item.asset.id"
                              class="d-flex align-center mt-1">
                              <v-icon color="grey darken-1" small class="mr-2">description</v-icon>
                              <a :href="item.asset.url" target="_blank" class="light-blue--text text-decoration-none"
                                style="font-size: 13px;">
                                {{ item.asset.name }}
                              </a>
                              <span v-if="item.asset.description" class="ml-2 text-muted" style="font-size: 12px;">
                                <i>- {{ item.asset.description }}</i>
                              </span>
                            </div>
                          </div>

                        </v-card-text>
                        <v-divider></v-divider>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card>
              </v-card-text>
              <v-card-actions class="grey lighten-4 justify-center pb-1" style="padding: 0; margin:0;">
                <v-btn block flat color="grey darken-2" @click="panelState = null" style="margin: 0; height: 40px;">
                  <v-icon left>mdi-chevron-up</v-icon>
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>

          </v-expansion-panel-content>
        </v-expansion-panel>

      </div>
      <div style="display: flex; justify-content: center; align-items: center; margin-top: 3em;" v-else>
        <span>No posee permisos para ver esta sección</span>
      </div>
    </v-content>
  </div>
</template>

<script>
import CarouselInforme from '../../informes-auditorias/components/fields_components/CarouselInforme.vue'

export default {
  components: {
    CarouselInforme
  },
  data () {
    return {
      partidos: [],
      loading: true,
      busquedaCompletada: false,
      tabCategoria: 0,
      tabClub: 0,
      categorias: [],
      clubesFiltrados: [],
      partidosAgrupados: [],
      panelState: null
    }
  },
  props: {
    routeSelection: null,
    torneoId: null,
    fechaId: null,
    titleRoute: null
  },
  computed: {
    selectedCategoriaId () {
      if (this.categorias.length === 0) return null
      return this.categorias[this.tabCategoria].id
    },
    selectedClubId () {
      if (this.clubesFiltrados.length === 0 || this.tabClub === undefined || this.tabClub === null || this.tabClub === 0) return null
      const club = this.clubesFiltrados[this.tabClub - 1]
      return club ? (club.pk || club.id) : null
    },
    parametrosBusqueda () {
      return `${this.selectedCategoriaId}-${this.selectedClubId}`
    },
    cantidadConObservaciones () {
      return this.partidosAgrupados.filter(item => item.sanciones.length > 0).length
    }
  },
  watch: {
    selectedCategoriaId (newCategoriaId) {
      if (newCategoriaId) {
        this.fetchClubes(newCategoriaId)
      }
    },
    parametrosBusqueda (nuevoValor) {
      const [categoriaId, clubId] = nuevoValor.split('-')
      if (categoriaId !== 'null' && clubId !== 'null' && categoriaId !== 'undefined' && clubId !== 'undefined') {
        this.fetchReportesSanciones(categoriaId, clubId)
      } else {
        this.busquedaCompletada = false
        this.partidosAgrupados = []
      }
    }
  },
  methods: {
    getPartidoColor (partido) {
      if (partido.countIncumplimientos > 0) return '#e53935'
      if (partido.countAdvertencias > 0) return '#f57c00'
      return '#43a047'
    },
    getSancionPeso (description) {
      if (!description) return 0
      const descLower = description.toLowerCase()
      if (descLower.includes('incumplimiento')) return 2
      if (descLower.includes('advertencia')) return 1
      return 0
    },
    getSancionColor (description) {
      if (!description) return 'grey'
      const descLower = description.toLowerCase()
      if (descLower.includes('advertencia')) return 'orange darken-2'
      if (descLower.includes('incumplimiento')) return 'red darken-1'
      return 'grey'
    },
    getSancionColorHex (description) {
      if (!description) return '#9e9e9e'
      const descLower = description.toLowerCase()
      if (descLower.includes('advertencia')) return '#f57c00'
      if (descLower.includes('incumplimiento')) return '#e53935'
      return '#9e9e9e'
    },
    fetchReportesSanciones (categoriaId, clubId) {
      if (!this.$store.state.permissions.canViewObservacionesPreviasInformes) return false
      this.partidosAgrupados = []
      this.loading = true
      this.busquedaCompletada = false
      this.axios.get(`/sanciones/categoria/${categoriaId}/club/${clubId}/`)
        .then(response => {
          const datosProcesados = response.data.map(partidoAgrupado => {
            let countAdvertencias = 0
            let countIncumplimientos = 0

            let sancionesMapeadas = partidoAgrupado.sanciones.map(sancion => {
              const descLower = sancion.sanction.description ? sancion.sanction.description.toLowerCase() : ''
              if (descLower.includes('advertencia')) countAdvertencias++
              if (descLower.includes('incumplimiento')) countIncumplimientos++

              const imageAdjuntos = []
              const filesAdjuntos = []

              if (sancion.fieldAdjuntos && sancion.fieldAdjuntos.length > 0) {
                sancion.fieldAdjuntos.forEach(adj => {
                  const fileType = adj.asset.fileType || ''
                  if (fileType.match('image.*') || fileType.match('video.*')) {
                    imageAdjuntos.push(adj)
                  } else {
                    filesAdjuntos.push(adj)
                  }
                })
              }

              return {
                ...sancion,
                imageAdjuntos,
                filesAdjuntos
              }
            })

            sancionesMapeadas.sort((a, b) => {
              const pesoA = this.getSancionPeso(a.sanction.description)
              const pesoB = this.getSancionPeso(b.sanction.description)
              return pesoB - pesoA
            })

            partidoAgrupado.sanciones = sancionesMapeadas
            partidoAgrupado.partido.countAdvertencias = countAdvertencias
            partidoAgrupado.partido.countIncumplimientos = countIncumplimientos

            return partidoAgrupado
          })

          datosProcesados.sort((a, b) => {
            const parseFecha = (fechaStr) => {
              if (!fechaStr) return 0
              const [fecha, hora] = fechaStr.split(' ')
              const [dia, mes, anio] = fecha.split('/')
              const [h, m] = hora ? hora.split(':') : [0, 0]
              return new Date(anio, mes - 1, dia, h, m).getTime()
            }

            return parseFecha(b.partido.dateRealization) - parseFecha(a.partido.dateRealization)
          })

          this.partidosAgrupados = datosProcesados
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
        .finally(() => {
          this.loading = false
          this.busquedaCompletada = true
        })
    },

    fetchCategoriasInit () {
      this.loading = true
      this.partidosAgrupados = []
      this.axios.get('/informe-auditoria/categorias')
        .then(response => {
          this.categorias = response.data

          const queryCatId = this.$route.query.categoriaId
          if (queryCatId) {
            const index = this.categorias.findIndex(c => c.id === queryCatId)
            if (index !== -1) {
              this.tabCategoria = index
            }
          }
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
        .finally(() => {
          this.loading = false
        })
    },

    fetchClubes (categoriaId) {
      this.clubesFiltrados = []
      this.loading = true
      this.partidosAgrupados = []
      this.axios.get(`/clubes-logos?categories=${categoriaId}`)
        .then(response => {
          this.clubesFiltrados = response.data
          const queryClubId = this.$route.query.clubId

          if (queryClubId) {
            const index = this.clubesFiltrados.findIndex(c => (c.pk || c.id) === queryClubId)

            if (index !== -1) {
              this.tabClub = index + 1

              let query = Object.assign({}, this.$route.query)
              delete query.clubId
              this.$router.replace({ query }).catch(() => {})
            } else {
              this.tabClub = 0
            }
          } else {
            this.tabClub = 0
          }
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.fetchCategoriasInit()
  }
}
</script>

<style scoped>
.tabs-categorias {
  border-bottom: 1px solid #c8ced5;
  box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.15) !important;
}

.club-tab-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.v-tab {
  font-family: SourceSansProRegular, sans-serif !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.body-content {
  background-color: white;
  min-height: 50em;
  padding: 0 0 3em 0 !important;
}

.ruta-container {
  margin-top: 0em;
  margin-bottom: 1em;
  font-size: 1.6em;
  font-family: SourceSansProRegular, sans-serif;
  color: #293968;
}

.no-content-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: large;
  justify-content: center;
  align-content: center;
  color: #676767;
}

.logo-mini {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.header-partido {
  font-size: 1rem;
  align-items: center
}

.text-muted {
  color: #757575;
  font-size: 0.9em;
}

.sancion-card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.panel-compacto .v-expansion-panel__header {
  min-height: 40px !important;
  padding: 8px 16px !important;
}

.adjuntos-panel {
  background-color: transparent !important;
}

.adjuntos-panel .v-expansion-panel__header {
  padding: 0 !important;
  min-height: 30px !important;
  background-color: transparent !important;
}

.adjuntos-panel .v-expansion-panel__body {
  background-color: transparent !important;
}

.border-top-light {
  border-top: 1px dashed #e0e0e0;
}

.tabs-clubes {
  border-bottom: 1px solid #c8ced5;
  box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.15) !important;
}

.borde-estado {
  position: relative;
}

.borde-estado::before {
  content: '';
  position: absolute;
  left: 0px;
  top: 5px;
  bottom: 5px;
  width: 3px;
  background-color: var(--color-estado);
  border-radius: 4px;
  z-index: 1;
}

.panel-sin-sanciones >>> .v-expansion-panel__header {
  cursor: default !important;
}
</style>
